import React from 'react'
import { createPortal } from 'react-dom'
import ClientDashboardLoginOverlay from 'src/components/shared/ClientDashboardLoginOverlay'
import { useClientDashboardLogin } from './ClientDashboardLoginContext'

const ClientDashboardLoginOverlayGate = ({ footerProps }) => {
  const { isOpen, closeLoginOverlay, openedFromShowFormCookie } =
    useClientDashboardLogin()

  if (!isOpen || typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <ClientDashboardLoginOverlay
      onClose={closeLoginOverlay}
      footerProps={footerProps}
      openedFromShowFormCookie={openedFromShowFormCookie}
    />,
    document.body
  )
}

export default ClientDashboardLoginOverlayGate
